import React from 'react';

import { SignatureModalContextProvider } from 'signer-app/signature-modal/contexts/signature-modal/context';
import { CanvasContextProvider } from 'signer-app/signature-modal/contexts/canvas/context';
import SignatureField, {
  SignatureFieldProps,
} from './signature-field/signature-field';

export default function StandaloneSignatureField(props: SignatureFieldProps) {
  return (
    <CanvasContextProvider>
      <SignatureModalContextProvider>
        <SignatureField {...props} />
      </SignatureModalContextProvider>
    </CanvasContextProvider>
  );
}
